module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/volodymyr-ivash-bkg-997c29c1c15dc167986ea8a04c7c5c65.jpg";